import en from './en';

// English is kept as the fallback baseline; translated keys below override it.
const th = {
  ...en,
  " · 만료됨": " · หมดอายุ",
  "(password 있음)": "(ตั้งรหัสผ่านแล้ว)",
  "(링크 없음)": "(ไม่มีลิงก์)",
  "(본문 없음)": "(ไม่มีเนื้อหา)",
  "(없음)": "(ไม่มี)",
  "(이름없음)": "(ไม่มีชื่อ)",
  "(자동)": "(อัตโนมัติ)",
  "(제목 없음)": "(ไม่มีหัวข้อ)",
  "+ 공지 작성": "+ สร้างประกาศ",
  "+ 광고 등록": "+ เพิ่มโฆษณา",
  "+ 새 공지 작성": "+ ประกาศใหม่",
  "+ 새 광고 등록": "+ โฆษณาใหม่",
  "+ 아이콘(업로드)": "+ ไอคอน (อัปโหลด)",
  "+ 이미지": "+ รูปภาพ",
  "+ 인포 버튼 추가": "+ เพิ่มปุ่มข้อมูล",
  "+ 인포카드 추가": "+ เพิ่มการ์ดข้อมูล",
  "+ 텍스트": "+ ข้อความ",
  "0 이상 숫자를 입력하세요.": "ป้อนตัวเลขที่มากกว่าหรือเท่ากับ 0",
  "0보다 큰 금액을 입력하세요.": "ป้อนจำนวนเงินที่มากกว่า 0",
  "0보다 큰 숫자만 가능": "อนุญาตเฉพาะตัวเลขที่มากกว่า 0",
  "24시간 반복": "ทำซ้ำทุก 24 ชั่วโมง",
  "2차 비밀번호(선택)": "รหัสผ่านชั้นที่สอง (ไม่บังคับ)",
  "Country 필터": "ตัวกรองประเทศ",
  "Device 필터": "ตัวกรองอุปกรณ์",
  "DisplaySet 날짜 필터(1일 단위)": "ตัวกรองวันที่ DisplaySet (หน่วย 1 วัน)",
  "Due Date를 올바른 날짜/시간으로 입력해야 합니다.": "ป้อนวัน/เวลาครบกำหนดที่ถูกต้อง",
  "Due Date를 입력해야 합니다.": "จำเป็นต้องระบุวันครบกำหนด",
  "Rake % (수수료율)": "Rake % (อัตราค่าธรรมเนียม)",
  "SB/BB는 0보다 큰 숫자이며 소수점은 최대 2자리까지 입력할 수 있습니다. 예: 0.25 / 0.50": "SB/BB ต้องเป็นตัวเลขมากกว่า 0 และมีทศนิยมได้สูงสุด 2 ตำแหน่ง เช่น 0.25 / 0.50",
  "agent_share는 0~1 사이 숫자만 가능 (예: 0.2)": "agent_share ต้องเป็นตัวเลขระหว่าง 0 ถึง 1 (เช่น 0.2)",
  "endAt은 startAt보다 늦어야 해.": "endAt ต้องช้ากว่า startAt",
  "message는 빈값이 될 수 없습니다.": "ข้อความต้องไม่ว่าง",
  "message는 필수입니다.": "จำเป็นต้องกรอกข้อความ",
  "⚠️ 권한이 없습니다": "⚠️ คุณไม่มีสิทธิ์",
  "개": "รายการ",
  "개 · 남은 수량": "รายการ · จำนวนคงเหลือ",
  "갱신 주기(일)": "รอบการต่ออายุ (วัน)",
  "건": "รายการ",
  "검색": "ค้นหา",
  "검색 (id / user_code / nickname / 메모)": "ค้นหา (id / user_code / ชื่อเล่น / บันทึก)",
  "검색: 이름/링크/국가": "ค้นหา: ชื่อ/ลิงก์/ประเทศ",
  "검색: 제목/본문/작성자": "ค้นหา: ชื่อเรื่อง/เนื้อหา/ผู้เขียน",
  "검색어를 입력하세요": "ป้อนคำค้นหา",
  "게시": "เผยแพร่แล้ว",
  "게시 상태": "สถานะเผยแพร่",
  "게시 중": "กำลังเผยแพร่",
  "결제 영역": "พื้นที่ชำระเงิน",
  "결제 옵션": "ตัวเลือกการชำระเงิน",
  "결제 옵션 추가": "เพิ่มตัวเลือกการชำระเงิน",
  "결제 완료": "ชำระเงินสำเร็จ",
  "결제 항목": "รายการชำระเงิน",
  "결제관리": "จัดการการชำระเงิน",
  "경로": "เส้นทาง",
  "공지 관리": "จัดการประกาศ",
  "공지 본문": "เนื้อหาประกาศ",
  "공지 수정": "แก้ไขประกาศ",
  "공지 작성/관리": "สร้าง/จัดการประกาศ",
  "공지 제목": "หัวข้อประกาศ",
  "공지가 없어. 위에서 새로 작성해줘.": "ไม่มีประกาศ กรุณาสร้างใหม่ด้านบน",
  "관리": "จัดการ",
  "관리 상태": "สถานะผู้ดูแล",
  "관리자 자산 표시 영역": "พื้นที่สรุปสินทรัพย์ผู้ดูแล",
  "광고 관리": "จัดการโฆษณา",
  "광고 목록을 불러오지 못했어.": "โหลดรายการโฆษณาไม่สำเร็จ",
  "광고 삭제에 실패했어.": "ลบโฆษณาไม่สำเร็จ",
  "광고 수정": "แก้ไขโฆษณา",
  "광고 이미지": "รูปภาพโฆษณา",
  "광고 이미지 등록/관리": "ลงทะเบียน/จัดการรูปภาพโฆษณา",
  "광고 이미지를 업로드해줘.": "กรุณาอัปโหลดรูปโฆษณา",
  "광고 저장에 실패했어.": "บันทึกโฆษณาไม่สำเร็จ",
  "국가(country)를 입력해줘. 예: KR / US / JP / ALL": "ป้อนประเทศ เช่น KR / US / JP / ALL",
  "굵기": "น้ำหนัก",
  "그룹 노출(DisplaySet)": "การแสดงกลุ่ม (DisplaySet)",
  "그룹 미션": "ภารกิจกลุ่ม",
  "그룹 미션 설정": "ตั้งค่าภารกิจกลุ่ม",
  "그룹 미션 시작": "เริ่มภารกิจกลุ่ม",
  "그룹 생성": "สร้างกลุ่ม",
  "그룹 시간 설정이 올바르지 않습니다.": "การตั้งค่าเวลากลุ่มไม่ถูกต้อง",
  "그룹 이름": "ชื่อกลุ่ม",
  "그룹 이름, Small Blind, Big Blind는 필수 입력입니다. SB/BB는 예: 0.25, 0.50처럼 입력할 수 있습니다.": "ต้องกรอกชื่อกลุ่ม, Small Blind และ Big Blind โดย SB/BB สามารถใส่เช่น 0.25, 0.50",
  "그룹명": "ชื่อกลุ่ม",
  "글로벌": "ทั่วโลก",
  "금액": "จำนวนเงิน",
  "금액은 최소 50$ 이상 부터 가능합니다.": "จำนวนเงินต้องอย่างน้อย $50",
  "기간": "ช่วงเวลา",
  "나의 지갑 주소": "ที่อยู่กระเป๋าของฉัน",
  "남미": "อเมริกาใต้",
  "내부용 이름(label)": "ชื่อภายใน (label)",
  "내부용 이름(label)을 입력해줘.": "ป้อนชื่อภายใน (label)",
  "내용(message)": "เนื้อหา (message)",
  "노출": "แสดง",
  "노출(즉시/기간무관)": "แสดง (ทันที / ไม่จำกัดช่วงเวลา)",
  "노출중": "แสดง",
  "닉네임": "ชื่อเล่น",
  "다음": "ถัดไป",
  "닫기": "ปิด",
  "데이터 없음": "ไม่มีข้อมูล",
  "데이터가 없습니다.": "ไม่มีข้อมูล",
  "동남아": "เอเชียตะวันออกเฉียงใต้",
  "동아시아": "เอเชียตะวันออก",
  "등록": "ลงทะเบียน",
  "등록된 광고가 없어.": "ไม่มีโฆษณาที่ลงทะเบียน",
  "등록된 라운지 글이 없습니다.": "ไม่มีโพสต์เลานจ์ที่ลงทะเบียน",
  "등록된 이미지 없음": "ไม่มีรูปภาพที่ลงทะเบียน",
  "라운지 관리": "จัดการเลานจ์",
  "라운지 글": "โพสต์เลานจ์",
  "라운지 글 목록": "รายการโพสต์เลานจ์",
  "라운지 목록을 불러오지 못했습니다.": "โหลดรายการเลานจ์ไม่สำเร็จ",
  "라운지 아이템": "รายการเลานจ์",
  "라운지 업로드": "อัปโหลดเลานจ์",
  "라운지 포인트 %": "เปอร์เซ็นต์แต้มเลานจ์",
  "라운지 포인트 % (0~100)": "เปอร์เซ็นต์แต้มเลานจ์ (0–100)",
  "라운지 포인트 %는 0~100 사이 숫자이며 소수점은 최대 2자리까지 가능합니다.": "เปอร์เซ็นต์แต้มเลานจ์ต้องเป็นตัวเลข 0 ถึง 100 และมีทศนิยมได้สูงสุด 2 ตำแหน่ง",
  "라운지 포인트 지급률": "อัตราจ่ายแต้มเลานจ์",
  "라운지 포인트 지급률 저장 실패": "บันทึกอัตราจ่ายแต้มเลานจ์ไม่สำเร็จ",
  "라운지포인트": "แต้มเลานจ์",
  "레이크백": "เรคแบ็ก",
  "로그아웃": "ออกจากระบบ",
  "로그인": "เข้าสู่ระบบ",
  "로그인 실패: ": "เข้าสู่ระบบไม่สำเร็จ: ",
  "로딩 중...": "กำลังโหลด...",
  "로딩중...": "กำลังโหลด...",
  "링크 열기": "เปิดลิงก์",
  "링크:": "ลิงก์:",
  "만료": "หมดอายุ",
  "메모": "บันทึก",
  "메인 영역": "พื้นที่หลัก",
  "명": "ผู้ใช้",
  "무한(30일 갱신)": "ไม่จำกัด (ต่ออายุ 30 วัน)",
  "무한(infinite) 항목(상시 노출)": "รายการไม่จำกัด (แสดงตลอดเวลา)",
  "무한(약 {days}일 단위 갱신)": "ไม่จำกัด (ต่ออายุประมาณทุก {days} วัน)",
  "미결제": "ยังไม่ชำระ",
  "미리보기": "ดูตัวอย่าง",
  "미션 RUN 생성 실패": "สร้าง RUN ภารกิจไม่สำเร็จ",
  "미션 cfg 저장 실패": "บันทึก cfg ภารกิจไม่สำเร็จ",
  "미션 상금 분배(프론트 계산)": "การแบ่งรางวัลภารกิจ (คำนวณฝั่งหน้าเว็บ)",
  "미션 상태 조회 실패": "โหลดสถานะภารกิจไม่สำเร็จ",
  "받는 지갑": "กระเป๋ารับเงิน",
  "받는쪽 (to)": "ผู้รับ (to)",
  "배경 색상": "สีพื้นหลัง",
  "배경 이미지 URL": "URL รูปพื้นหลัง",
  "배경 타입": "ประเภทพื้นหลัง",
  "보내는 지갑": "กระเป๋าส่งเงิน",
  "보낸쪽 (from)": "ผู้ส่ง (from)",
  "복사": "คัดลอก",
  "복사 실패(브라우저 권한 확인)": "คัดลอกไม่สำเร็จ (ตรวจสอบสิทธิ์เบราว์เซอร์)",
  "본문": "เนื้อหา",
  "본문 내용을 입력하세요": "ป้อนเนื้อหา",
  "본문을 입력해줘.": "ป้อนเนื้อหา",
  "본인 {id}": "ตัวเอง {id}",
  "북미": "อเมริกาเหนือ",
  "분배 비율": "อัตราการแบ่ง",
  "분배 비율(상대 %)": "อัตราการแบ่ง (% สัมพัทธ์)",
  "불러오기 실패": "โหลดไม่สำเร็จ",
  "불러오는 중…": "กำลังโหลด…",
  "비밀번호": "รหัสผ่าน",
  "비활성": "ปิดใช้งาน",
  "삭제": "ลบ",
  "삭제 실패": "ลบไม่สำเร็จ",
  "삭제됨": "ลบแล้ว",
  "상세": "รายละเอียด",
  "상시": "ตลอดเวลา",
  "상위 에이전트:": "เอเยนต์ต้นสังกัด:",
  "상태": "สถานะ",
  "새 공지 작성": "สร้างประกาศใหม่",
  "새 광고 등록": "สร้างโฆษณาใหม่",
  "새 전광판 등록": "สร้างข้อความวิ่งใหม่",
  "새로고침": "รีเฟรช",
  "색상": "สี",
  "생성": "สร้าง",
  "생성 중...": "กำลังสร้าง...",
  "생성 중…": "กำลังสร้าง…",
  "서버 오류": "ข้อผิดพลาดเซิร์ฟเวอร์",
  "서버로 전송될 preset 문자열(콤마 구분)": "สตริง preset ที่ส่งไปเซิร์ฟเวอร์ (คั่นด้วยจุลภาค)",
  "세컨드 비밀번호(옵션)": "รหัสผ่านชั้นที่สอง (ไม่บังคับ)",
  "소속 유저": "ผู้ใช้ที่สังกัด",
  "수량": "จำนวน",
  "수수료": "ค่าธรรมเนียม",
  "수수료 수정": "แก้ไขค่าธรรมเนียม",
  "수수료 수정 실패": "แก้ไขค่าธรรมเนียมไม่สำเร็จ",
  "수정": "แก้ไข",
  "수정 모드": "โหมดแก้ไข",
  "시간 설정": "ตั้งค่าเวลา",
  "시간 설정이 올바르지 않습니다.": "การตั้งค่าเวลาไม่ถูกต้อง",
  "시작": "เริ่ม",
  "시작(로컬)": "เริ่ม (เวลาท้องถิ่น)",
  "시작일": "วันที่เริ่ม",
  "아래로": "ลง",
  "아이콘 파일은 1MB 이하로 올려주세요.": "ไฟล์ไอคอนต้องไม่เกิน 1MB",
  "아프리카": "แอฟริกา",
  "언어": "ภาษา",
  "업로드": "อัปโหลด",
  "업로드 URL을 받지 못했습니다.": "ไม่ได้รับ URL อัปโหลด",
  "업로드 URL을 받지 못했어.": "ไม่ได้รับ URL อัปโหลด",
  "업로드/게시": "อัปโหลด/เผยแพร่",
  "업로드중...": "กำลังอัปโหลด...",
  "에이전트": "เอเยนต์",
  "에이전트 상금풀(": "เงินรางวัลเอเยนต์ (",
  "에이전트로 생성": "สร้างเป็นเอเยนต์",
  "예약": "ตั้งเวลาแล้ว",
  "예약 시간이 올바르지 않습니다.": "เวลาที่ตั้งไว้ไม่ถูกต้อง",
  "예약 없음": "ไม่มีกำหนดเวลา",
  "예약/상태": "กำหนดเวลา/สถานะ",
  "오래된순": "เก่าสุดก่อน",
  "요소(최대 4개)": "องค์ประกอบ (สูงสุด 4)",
  "요청 실패 ({status})": "คำขอล้มเหลว ({status})",
  "용량": "ขนาด",
  "위로": "ขึ้น",
  "유럽": "ยุโรป",
  "유저 관리": "จัดการผู้ใช้",
  "유저코드": "รหัสผู้ใช้",
  "유효 인포메이션 버튼:": "ปุ่มข้อมูลที่ถูกต้อง:",
  "이 페이지에 접근할 수 있는 권한이 없습니다.": "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
  "이동 URL": "URL ปลายทาง",
  "이미지": "รูปภาพ",
  "이미지 URL": "URL รูปภาพ",
  "이미지 블록": "บล็อกรูปภาพ",
  "이미지 업로드 실패: {message}": "อัปโหลดรูปภาพไม่สำเร็จ: {message}",
  "이미지 업로드 중...": "กำลังอัปโหลดรูปภาพ...",
  "이미지 업로드에 실패했습니다.": "อัปโหลดรูปภาพไม่สำเร็จ",
  "이미지 업로드중...": "กำลังอัปโหลดรูปภาพ...",
  "이미지 없음": "ไม่มีรูปภาพ",
  "이미지 열기": "เปิดรูปภาพ",
  "이미지 파일만 등록할 수 있어.": "ลงทะเบียนได้เฉพาะไฟล์รูปภาพ",
  "이미지 파일만 업로드할 수 있어.": "อัปโหลดได้เฉพาะไฟล์รูปภาพ",
  "이미지(URL)": "รูปภาพ (URL)",
  "이미지는 5MB 이하만 업로드할 수 있어.": "รูปภาพต้องมีขนาดไม่เกิน 5MB",
  "이전": "ก่อนหน้า",
  "인포 버튼 시간 설정이 올바르지 않습니다.": "การตั้งค่าเวลาปุ่มข้อมูลไม่ถูกต้อง",
  "인포 버튼 프리셋 수정": "แก้ไขพรีเซ็ตปุ่มข้อมูล",
  "인포메이션 버튼(선택)": "ปุ่มข้อมูล (ไม่บังคับ)",
  "인포버튼 없음": "ไม่มีปุ่มข้อมูล",
  "인포버튼 프리셋 수정": "แก้ไขพรีเซ็ตปุ่มข้อมูล",
  "인포카드 추가": "เพิ่มการ์ดข้อมูล",
  "인포카드 타이머": "ตัวจับเวลาการ์ดข้อมูล",
  "일": "วัน",
  "일 /": "วัน /",
  "일/": "วัน/",
  "일반 자산": "สินทรัพย์หลัก",
  "임시": "ฉบับร่าง",
  "임시저장": "ฉบับร่าง",
  "입력값을 확인해 주세요.": "กรุณาตรวจสอบค่าที่ป้อน",
  "자산": "สินทรัพย์",
  "자산 타입": "ประเภทสินทรัพย์",
  "자산기록": "บัญชีรายการสินทรัพย์",
  "작성": "สร้าง",
  "작성자": "ผู้เขียน",
  "재시작": "เริ่มใหม่",
  "저장": "บันทึก",
  "저장 중...": "กำลังบันทึก...",
  "저장중...": "กำลังบันทึก...",
  "적용": "ใช้",
  "전광판 관리": "จัดการข้อความวิ่ง",
  "전광판 등록 실패": "สร้างข้อความวิ่งไม่สำเร็จ",
  "전광판 목록 조회 실패": "โหลดรายการข้อความวิ่งไม่สำเร็จ",
  "전광판 삭제 실패": "ลบข้อความวิ่งไม่สำเร็จ",
  "전광판 수정 실패": "แก้ไขข้อความวิ่งไม่สำเร็จ",
  "전체": "ทั้งหมด",
  "전체 상태": "สถานะรวม",
  "접기": "ยุบ",
  "정렬": "เรียงลำดับ",
  "정렬 변경에 실패했어.": "เปลี่ยนลำดับไม่สำเร็จ",
  "정렬 저장": "บันทึกลำดับ",
  "정렬 저장 실패": "บันทึกลำดับไม่สำเร็จ",
  "정보 수정 실패": "แก้ไขข้อมูลไม่สำเร็จ",
  "정보수정": "แก้ไขข้อมูล",
  "정상": "ปกติ",
  "제거": "นำออก",
  "제목": "หัวข้อ",
  "제목을 입력하세요": "ป้อนหัวข้อ",
  "제목을 입력해줘.": "ป้อนหัวข้อ",
  "조회": "ค้นหา",
  "종료(로컬)": "สิ้นสุด (เวลาท้องถิ่น)",
  "종료일": "วันที่สิ้นสุด",
  "중동": "ตะวันออกกลาง",
  "중앙아시아": "เอเชียกลาง",
  "중지": "หยุด",
  "지갑 주소": "ที่อยู่กระเป๋าเงิน",
  "지금": "ตอนนี้",
  "지급": "เพิ่มเครดิต",
  "지급 실패": "เพิ่มเครดิตไม่สำเร็จ",
  "차감": "หักเงิน",
  "차감 실패": "หักเงินไม่สำเร็จ",
  "차단": "บล็อก",
  "차단 해제": "ปลดบล็อก",
  "차단됨": "ถูกบล็อก",
  "처리 중...": "กำลังดำเนินการ...",
  "초기화": "รีเซ็ต",
  "초안": "ฉบับร่าง",
  "총 상금풀(1.5%):": "เงินรางวัลรวม (1.5%):",
  "총베팅액:": "ยอดเดิมพันรวม:",
  "최근순": "ใหม่สุดก่อน",
  "출금하기": "ถอนเงิน",
  "충전 하기": "ฝากเงิน",
  "취소": "ยกเลิก",
  "카테고리": "หมวดหมู่",
  "크기(px)": "ขนาด (px)",
  "클릭 시 출금이 시작 됩니다.": "การถอนจะเริ่มเมื่อคลิก",
  "클릭 이동 URL(link_url)": "URL เมื่อคลิก (link_url)",
  "클릭 이동 링크(URL)": "ลิงก์เมื่อคลิก (URL)",
  "클릭하면 등록 모달": "คลิกเพื่อเปิดหน้าต่างลงทะเบียน",
  "클릭하면 표시 기준 시간이 해당 날짜로 설정됩니다": "คลิกเพื่อตั้งเวลาอ้างอิงการแสดงผลเป็นวันที่นี้",
  "클릭하여 이미지 업로드": "คลิกเพื่ออัปโหลดรูปภาพ",
  "타이머 없음": "ไม่มีตัวจับเวลา",
  "타이머 타입": "ประเภทตัวจับเวลา",
  "타이머(존재유무만)": "ตัวจับเวลา (มี/ไม่มีเท่านั้น)",
  "타이머는": "ตัวจับเวลาคือ",
  "타입": "ประเภท",
  "테이블 관리": "จัดการโต๊ะ",
  "테이블 그룹 목록 조회 실패": "โหลดรายการกลุ่มโต๊ะไม่สำเร็จ",
  "테이블 그룹 생성 실패": "สร้างกลุ่มโต๊ะไม่สำเร็จ",
  "테이블 그룹 생성 완료": "สร้างกลุ่มโต๊ะสำเร็จ",
  "테이블 그룹 코드 생성 실패": "สร้างรหัสกลุ่มโต๊ะไม่สำเร็จ",
  "테이블 그룹이 없습니다.": "ไม่มีกลุ่มโต๊ะ",
  "테이블 미션": "ภารกิจโต๊ะ",
  "테이블 미션 RUN 생성 실패": "สร้าง RUN ภารกิจโต๊ะไม่สำเร็จ",
  "테이블 미션 RUN 중지 실패": "หยุด RUN ภารกิจโต๊ะไม่สำเร็จ",
  "테이블 미션 cfg 저장 실패": "บันทึก cfg ภารกิจโต๊ะไม่สำเร็จ",
  "테이블 미션 상금 분배(프론트 계산)": "การแบ่งรางวัลภารกิจโต๊ะ (คำนวณฝั่งหน้าเว็บ)",
  "테이블 미션 상태 조회 실패": "โหลดสถานะภารกิจโต๊ะไม่สำเร็จ",
  "텍스트": "ข้อความ",
  "텍스트 블록": "บล็อกข้อความ",
  "텍스트 스타일": "สไตล์ข้อความ",
  "파일명": "ชื่อไฟล์",
  "판매": "ขายแล้ว",
  "페이지": "หน้า",
  "페이지 크기": "ขนาดหน้า",
  "펼치기": "ขยาย",
  "폰트스타일": "สไตล์ฟอนต์",
  "표시 기준 시간": "เวลาอ้างอิงการแสดงผล",
  "표시 순서(order)": "ลำดับการแสดงผล (order)",
  "표시 여부만": "เฉพาะสถานะการแสดง",
  "표시명": "ชื่อที่แสดง",
  "표시할 기록이 없습니다.": "ไม่มีรายการให้แสดง",
  "프론트 테스트: 송금 완료 처리(백엔드 연결 전)": "ทดสอบหน้าเว็บ: ประมวลผลการโอนเสร็จ (ก่อนเชื่อมต่อ backend)",
  "프론트 테스트: 출금 시작 처리(백엔드 연결 전)": "ทดสอบหน้าเว็บ: ประมวลผลเริ่มถอน (ก่อนเชื่อมต่อ backend)",
  "프리셋 수정": "แก้ไขพรีเซ็ต",
  "프리셋(배경/요소/URL)": "พรีเซ็ต (พื้นหลัง/องค์ประกอบ/URL)",
  "플레이어 상금풀(": "เงินรางวัลผู้เล่น (",
  "플레이어 수수료 설정": "ตั้งค่าค่าธรรมเนียมผู้เล่น",
  "하위": "บัญชีย่อย",
  "하위 {id}": "บัญชีย่อย {id}",
  "하위 계정 생성": "สร้างบัญชีย่อย",
  "하위 생성": "สร้างบัญชีย่อย",
  "하위 생성 (부모:": "สร้างบัญชีย่อย (ผู้ปกครอง:",
  "하이라이트 메세지": "ข้อความไฮไลต์",
  "하이라이트 포인트": "จุดไฮไลต์",
  "현재 라운지 포인트 %": "เปอร์เซ็นต์แต้มเลานจ์ปัจจุบัน",
  "확인용 테스트 거래 시작": "เริ่มธุรกรรมทดสอบ",
  "활성 RUN이 없습니다.": "ไม่มี RUN ที่ใช้งานอยู่",
  "회원 정보 수정": "แก้ไขข้อมูลสมาชิก",
  "🔐 어드민 로그인": "🔐 เข้าสู่ระบบผู้ดูแล",
};

export default th;
